(function ($) {

    // Stop execution if this is the wizard page
    if (document.body.classList.contains("page-template-tpl-wizard")) return;

    $(function () {

        window.gformConfirmationScroll = function() {
            return false;
        };
        
    });

} ) ( jQuery );